import React, { useState, useEffect } from 'react';
import ProductCard from '../ProductCard/ProductCard';
import { productService } from '../../services/api';
import { useCart } from '../../contexts/CartContext';
import styles from './ProduitEnPromotion.module.css';

const ProduitEnPromotion = () => {
  const [products, setProducts] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [sort, setSort] = useState('default');
  const { addToCart, isInCart, getProductQuantity } = useCart();

  useEffect(() => {
    loadOnSaleProducts();
  }, []);

  const loadOnSaleProducts = async () => {
    try {
      setIsLoading(true);
      setError(null);
      const response = await productService.getOnSaleProducts();

      if (response.success && response.data?.products) {
        setProducts(response.data.products);
      } else {
        setProducts([]);
      }
    } catch (err) {
      console.error('Erreur lors du chargement des produits en promotion:', err);
      setError('Erreur lors du chargement des produits');
      setProducts([]);
    } finally {
      setIsLoading(false);
    }
  };

  // Fonction pour gérer l'ajout au panier
  const handleAddToCart = async (productId) => {
    const result = await addToCart(productId, 1);
    if (result.success) {
      console.log('Produit ajouté au panier avec succès');
    } else {
      console.error('Erreur:', result.error);
    }
    return result; // IMPORTANT: Retourner le résultat pour ProductCard
  };

  // Sorting logic
  const sortedProducts = [...products].sort((a, b) => {
    if (sort === 'price-asc') {
      const priceA = parseFloat(a.sale_price || a.price || 0);
      const priceB = parseFloat(b.sale_price || b.price || 0);
      return priceA - priceB;
    }
    if (sort === 'price-desc') {
      const priceA = parseFloat(a.sale_price || a.price || 0);
      const priceB = parseFloat(b.sale_price || b.price || 0);
      return priceB - priceA;
    }
    if (sort === 'popular') {
      return (b.review_count || 0) - (a.review_count || 0);
    }
    return 0;
  });

  if (isLoading) {
    return (
      <section className={styles.productsSection}>
        <div className={styles.productsHeader}>
          <h2>Produits en promotions</h2>
        </div>
        <div className={styles.loading}>
          <p>Chargement des produits en promotion...</p>
        </div>
      </section>
    );
  }

  if (error) {
    return (
      <section className={styles.productsSection}>
        <div className={styles.productsHeader}>
          <h2>Produits en promotions</h2>
        </div>
        <div className={styles.error}>
          <p>{error}</p>
        </div>
      </section>
    );
  }

  if (products.length === 0) {
    return (
      <section className={styles.productsSection}>
        <div className={styles.productsHeader}>
          <h2>Produits en promotions</h2>
        </div>
        <div className={styles.empty}>
          <p>Aucun produit en promotion pour le moment.</p>
        </div>
      </section>
    );
  }

  return (
    <section className={styles.productsSection}>
      <div className={styles.productsHeader}>
        <h2>Produits en promotions</h2>
        <div className={styles.sorting}>
          <span>Tri par défaut</span>
          <select value={sort} onChange={(e) => setSort(e.target.value)}>
            <option value="default">Tri par défaut</option>
            <option value="price-asc">Prix croissant</option>
            <option value="price-desc">Prix décroissant</option>
            <option value="popular">Plus populaires</option>
          </select>
        </div>
      </div>
      <div className={styles.productsGrid}>
        {sortedProducts.map(product => (
          <ProductCard
            key={product.id}
            product={product}
            onAddToCart={handleAddToCart}
            isInCart={isInCart(product.id)}
            quantityInCart={getProductQuantity(product.id)}
          />
        ))}
      </div>
    </section>
  );
};

export default ProduitEnPromotion;